import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { MailIcon, ArrowRightIcon, ArrowLeftIcon } from '../components/Icons';
import * as authService from '../services/api/auth';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email) {
      setError('Please enter your email address');
      setLoading(false);
      return;
    }

    try {
      const result = await authService.forgotPassword(email.trim());

      if (result.success) {
        setSuccess(true);
      } else {
        setError(result.message || 'Unable to send OTP. Please try again.');
      }
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="forgot-password-screen">
        <div className="forgot-password-container">
          <div className="forgot-password-card success-content">
            <div className="fp-header">
              <button
                className="fp-header-back"
                onClick={() => navigate('/login')}
                aria-label="Back to login"
              >
                <ArrowLeftIcon size={20} color="currentColor" />
              </button>
              <h1 className="fp-header-title">Forgot Password</h1>
              <div className="fp-header-spacer" />
            </div>

            <div className="success-icon" aria-hidden="true">
              <svg width="72" height="72" viewBox="0 0 80 80" fill="none">
                <circle cx="40" cy="40" r="40" fill="#10b981" opacity="0.18" />
                <path d="M30 40L38 48L50 32" stroke="#10b981" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 className="success-title">OTP Sent</h2>
            <p className="success-message">
              We've sent a 6-digit OTP to <strong>{email}</strong>
            </p>
            <p className="success-submessage">
              Enter this OTP on the next screen to verify your identity and reset your password.
            </p>
            <button
              className="btn-primary fp-submit"
              onClick={() => navigate('/verify-otp', { state: { email } })}
            >
              Continue to Verify OTP
            </button>
            <div className="back-to-login">
              <Link to="/login" className="back-link">
                <ArrowLeftIcon size={16} color="currentColor" />
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-screen">
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <div className="fp-header">
            <button className="fp-header-back" onClick={() => navigate('/login')} aria-label="Back to login">
              <ArrowLeftIcon size={20} color="currentColor" />
            </button>
            <h1 className="fp-header-title">Forgot Password</h1>
            <div className="fp-header-spacer" />
          </div>

          <div className="forgot-password-content">
            <div className="forgot-password-icon" aria-hidden="true">
              <MailIcon size={58} color="#2563eb" />
            </div>
            <h2 className="forgot-password-title">Get OTP to Reset Password</h2>
            <p className="forgot-password-subtitle">
              Enter your email address and we'll send a 6-digit OTP. You will verify the OTP first, then set a new password.
            </p>

            <form onSubmit={handleSubmit} className="forgot-password-form">
              {error && <div className="error-message">{error}</div>}

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <div className="input-wrapper">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="input-field fp-input"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button type="submit" className="btn-primary fp-submit" disabled={loading}>
                {loading ? 'Sending OTP...' : 'Send OTP'}
                {!loading && <ArrowRightIcon size={18} color="#ffffff" />}
              </button>
            </form>

            <div className="back-to-login">
              <Link to="/login" className="back-link">
                <ArrowLeftIcon size={16} color="currentColor" />
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

